<template>
  <div class="page-list">
    <axe-pagination
      background
      prev-text="上一页"
      next-text="下一页"
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrent"
    >
    </axe-pagination>
  </div>
</template>

<script>
export default {
  props: {
    pageNum: Number,
    pageSize: Number,
    total: Number,
  },
  components: {},
  data () {
    return {
      page: 1,
    };
  },
  computed: {},
  watch: {},
  created () {
    this.page = this.pageNum;
  },
  mounted () { },
  methods: {
    changePage (val) {
      this.page = val;
    },
    handleCurrent () {
      this.$emit("handleCurrent", this.page);
    },
  },
};
</script>

<style scoped lang="scss">
.page-list {
  text-align: center;
}
.el-pagination.is-background {
  ::v-deep .btn-prev,
  ::v-deep.btn-next {
    border-radius: 4px;
    padding: 0 16px;
    border: 1px solid #d9d9d9;
    background: #fff;
    height: 32px;
    line-height: 32px;
    &:hover {
      border-color: #368fff;
      span {
        color: #368fff;
      }
    }
    span {
      line-height: 32px;
    }
  }
  ::v-deep .el-pager {
    .number {
      background: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      &:hover,
      &.active {
        border-color: #368fff;
        color: #368fff;
        background: #fff;
      }
    }
    .el-icon-more,
    li {
      height: 32px;
      line-height: 32px;
      min-width: 32px;
      background-color: #fff;
    }
    li {
      width: inherit;
    }
  }
}
</style>
